import { useState, useCallback } from 'react';

export default (initValue = '') => {
    const [value, setter] = useState(initValue === undefined ? '' : initValue);
    const handler = useCallback((e) => {
        setter((e.target.type === 'checkbox') ? e.target.checked ? 1 : 0 : e.target.value);
    }, []);
    return [value, handler, setter];
};
